import { getCurrentUserEmail } from '../auth';
import { getEightDInfoId } from '../eightDInfoStore';

const toIsoOrNull = (date) => {
  if (!date) return null;
  try {
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString();
  } catch {
    return null;
  }
};

export const buildD2Payload = ({
  d2Id = null,
  eightDInfoId,
  whatProblem = '',
  whyProblem = '',
  whenProblemDiscovered = '',
  whereProblemDiscovered = '',
  byWhomProblemDiscovered = '',
  howProblemDetected = '',
  defectivePartComment = '',
  areOtherPartNumberAffected = false,
  reference = '',
  responsiblePerson = '',
  plannedDate = null,
  achievedDate = null,
  uploadedFiles = [],
  defectivePartsDetected = [],
  isDisabled = false,
  attachmentsToRemove = [],
  defectivePartsDetectedtoRemove = [],
  createdBy = getCurrentUserEmail(),
  modifiedBy = getCurrentUserEmail(),
}) => {
  const finalEightDInfoId = eightDInfoId || getEightDInfoId();
  const nowIso = new Date().toISOString();

  const Attachments = (uploadedFiles || []).filter(f => !f.isExisting).map((f) => {
    const base64Data = f.preview || '';
    const attachmentData = base64Data.startsWith('data:') ? base64Data : base64Data ? `data:${f.file?.type || 'image/jpeg'};base64,${base64Data}` : '';
    return {
      EightDInfoId: finalEightDInfoId,
      AttachmentName: f.file?.name || '',
      AttachmentType: f.file?.type || '',
      AttachmentData: attachmentData,
      CreatedBy: createdBy || '',
      CreatedOn: nowIso,
      ModifiedBy: modifiedBy || '',
      ModifiedOn: nowIso,
    };
  });

  const DefectivePartsDetected = (defectivePartsDetected || []).map((part) => ({
    ...(part.D2DefectPartId ? { D2DefectPartId: Number(part.D2DefectPartId) } : {}),
    EightDInfoId: finalEightDInfoId,
    DetectedDate: toIsoOrNull(part.detectedDate),
    NoOfPartsDetected: part.noOfPartsDetected || 0,
    CreatedBy: createdBy || '',
    CreatedOn: nowIso,
    ModifiedBy: modifiedBy || '',
    ModifiedOn: nowIso,
  }));

  return {
    ...(d2Id ? { D2Id: d2Id } : {}),
    EightDInfoId: finalEightDInfoId,
    WhatProblem: whatProblem || '',
    WhyProblem: whyProblem || '',
    WhenProblemDiscovered: whenProblemDiscovered || '',
    WhereProblemDiscovered: whereProblemDiscovered || '',
    ByWhomProblemDiscovered: byWhomProblemDiscovered || '',
    HowProblemDetected: howProblemDetected || '',
    DefectivePartComment: defectivePartComment || '',
    AreOtherPartNumberAffected: areOtherPartNumberAffected,
    Reference: reference || '',
    ResponsiblePerson: responsiblePerson || '',
    PlannedDate: toIsoOrNull(plannedDate),
    AchievedDate: toIsoOrNull(achievedDate),
    CreatedBy: createdBy || '',
    CreatedOn: nowIso,
    ModifiedBy: modifiedBy || '',
    ModifiedOn: nowIso,
    Attachments,
    IsDisabled: Boolean(isDisabled),
    DefectivePartsDetected,
    DefectivePartsDetectedToRemove: defectivePartsDetectedtoRemove || [],
    AttachmentsToRemove: attachmentsToRemove || [],
  };
};
